const hasUsableContextUsage = usage => Boolean(
  usage && Number(usage.inputTokens || 0) > 0
)

const usageValueForModel = (usage, modelId) => {
  if (!usage || typeof usage !== 'object') return null
  if (hasUsableContextUsage(usage)) return usage
  if (hasUsableContextUsage(usage[modelId])) return usage[modelId]
  const routed = Object.entries(usage).find(([key, value]) => (
    key.endsWith(`:${modelId}`) && hasUsableContextUsage(value)
  ))
  if (routed) return routed[1]
  const values = Object.values(usage).filter(hasUsableContextUsage)
  return values.length === 1 ? values[0] : null
}

const selectReplyContextUsage = (event, modelId) => {
  const usage = usageValueForModel(event && event.usage, modelId)
  return usage
    ? { usage, blocked: false, source: 'conversation-event' }
    : { usage: null, blocked: false, source: 'unavailable' }
}

module.exports = {
  selectReplyContextUsage,
  usageValueForModel
}
